import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService, AuthService, ProviderName, SalesForceAuthService } from '@fgb/core';
import { CookieService } from 'ngx-cookie-service';
import { map, of, tap } from 'rxjs';

@Component({
  selector: 'fgb-sales-force-callback',
  templateUrl: './sales-force-callback.component.html',
  styleUrl: './sales-force-callback.component.scss',
})
export class SalesForceCallbackComponent implements OnInit {
  cookieName: string = '_sf_sso_upid';
  constructor(
    private salesForceAuthService: SalesForceAuthService,
    private router: Router,
    private cookieService: CookieService,
    private authService: AuthService,
    private api: ApiService
  ) {}

  ngOnInit() {
    if (this.authService.isAuthenticated()) {
      // already logged in
      this.router.navigate(['/']);
    } else if (this.salesForceAuthService.hasNamedCookie(this.cookieName)) {
      // login through cookies
      let domainCookie = this.getDomainCookie();
      this.authenticateDomainCookie(domainCookie);
    } else {
      // log through a code
      this.authenticateCode();
    }
  }

  /**
   * make request to authenticate domain
   * cookie if found.
   * If failed then will call authenticate JWT.
   * @param domainCookie domain cookie to
   * be authenticated.
   */
  authenticateDomainCookie(domainCookie: string) {
    this.salesForceAuthService
      .loginUsingToken(domainCookie)
      .toPromise()
      .catch(() => {
        this.authenticateCode();
      });
  }

  /**
   * call to athenticate JWT
   * if failed response will return
   * user to login page.
   */
  authenticateCode() {
    let sfcode = this.getProviderCodeToken('code');
    this.validateCode(sfcode)
      .toPromise()
      .catch((err) => {
        if (err.error.Code) {
          this.router.navigate(['/login'], { queryParams: { errorCode: err.error.Code } });
        }
      });
  }

  /**
   * Get a query string parameter without case sensitivity.
   * @param parameter the parameter that you require the information for
   */
  getProviderCodeToken(parameter: string): string {
    const url = window.location.href;
    let paramValue;

    if (url.includes('?')) {
      const httpParams = new HttpParams({ fromString: url.split('?')[1] });
      paramValue = httpParams.get(parameter);
    }

    if (paramValue) {
      return paramValue;
    }
    return '';
  }

  /**
   * Will check if domain cookie exists
   * and return this as a string.
   * @returns domain cookie from
   * sports alliance domain
   */
  getDomainCookie(): string {
    let domainCookie = '';
    domainCookie = this.cookieService.get(this.cookieName);

    return domainCookie;
  }

  validateCode(code: string, clubId: number = 1) {
    if (this.authService.hasAccessToken()) {
      return of(true);
    }

    return this.api.post(`sso/OAuth/${ProviderName.SalesForce}/${code}/${clubId}`, `"${code}"`).pipe(
      tap((authResponse: any) => {
        if (authResponse) {
          localStorage.setItem('SFRefreshToken', authResponse.auth.RefreshToken.toString());
          localStorage.setItem('SFAccessToken', authResponse.auth.AccessToken.toString());
          if (authResponse.tokens != null) {
            this.authService.loginUsingToken(authResponse.tokens.AccessToken, authResponse.tokens.RefreshToken, '/');
          } else {
            this.router.navigate(['/login'], { queryParams: { errorCode: '4567456' } });
          }
        }
      }),
      map((authResponse: any) => {
        if ((authResponse.status = 200)) {
          return true;
        } else {
          return false;
        }
      })
    );
  }
}
